import { AccountButtonStyle } from './AccountButton.style'
import { DoNotDisturbSplitButtonStyle } from './DoNotDisturbSplitButton.styles'
import { EnvironmentLabelStyle } from './EnvironmentLabel.style'
import { QueueControlButtonStyle } from './QueueControlButton.style'
import { TopNavStyle } from './TopNav.style'

export const topNavComponentStyles = {
  components: {
    AccountButtonStyle,
    DoNotDisturbSplitButtonStyle,
    EnvironmentLabelStyle,
    QueueControlButtonStyle,
    TopNavStyle,
  },
}
